'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDataUrlFromArr = getDataUrlFromArr;
exports.getImgFromDataUrl = getImgFromDataUrl;
exports.getImgFromArr = getImgFromArr;
/**
 * @function getDataUrlFromArr
 * @param {Uint8ClampedArray} arr
 * @param {int} w
 * @param {int} h
 * @returns {string}
 */
function getDataUrlFromArr(arr, w, h) {
  if (typeof w === 'undefined' || typeof h === 'undefined') {
    w = h = Math.sqrt(arr.length / 4);
  }

  var canvas = document.createElement('canvas');
  var ctx = canvas.getContext('2d');

  canvas.width = w;
  canvas.height = h;

  var imgData = ctx.createImageData(w, h);
  imgData.data.set(arr);
  ctx.putImageData(imgData, 0, 0);

  return canvas.toDataURL();
}

/**
 * @function getImgFromDataUrl
 * @param {string} data
 * @returns {HTMLImageElement}
 */
function getImgFromDataUrl(data) {
  var img = document.createElement('img');
  img.src = data;
  return img;
}

/**
 * @function getImgFromArr
 * @param {Uint8ClampedArray} arr
 * @param {int} w
 * @param {int} h
 * @returns {HTMLImageElement}
 */
function getImgFromArr(arr, w, h) {
  return getImgFromDataUrl(getDataUrlFromArr(arr, w, h));
}
